/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/CorporateStructureLink', 'model/ForecastModelDataEntry'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./CorporateStructureLink'), require('./ForecastModelDataEntry'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.ForecastModelAggregationLevelReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.CorporateStructureLink, root.ForStractionServiceApi.ForecastModelDataEntry);
  }
}(this, function(ApiClient, CorporateStructureLink, ForecastModelDataEntry) {
  'use strict';




  /**
   * The ForecastModelAggregationLevelReport model module.
   * @module model/ForecastModelAggregationLevelReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>ForecastModelAggregationLevelReport</code>.
   * @alias module:model/ForecastModelAggregationLevelReport
   * @class
   */
  var exports = function() {
    var _this = this;








  };

  /**
   * Constructs a <code>ForecastModelAggregationLevelReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ForecastModelAggregationLevelReport} obj Optional instance to populate.
   * @return {module:model/ForecastModelAggregationLevelReport} The populated <code>ForecastModelAggregationLevelReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Entries')) {
        obj['Entries'] = ApiClient.convertToType(data['Entries'], [ForecastModelDataEntry]);
      }
      if (data.hasOwnProperty('ModelID')) {
        obj['ModelID'] = ApiClient.convertToType(data['ModelID'], 'Integer');
      }
      if (data.hasOwnProperty('FatherID')) {
        obj['FatherID'] = ApiClient.convertToType(data['FatherID'], 'Integer');
      }
      if (data.hasOwnProperty('ChildrenTrackingLevelID')) {
        obj['ChildrenTrackingLevelID'] = ApiClient.convertToType(data['ChildrenTrackingLevelID'], 'Integer');
      }
      if (data.hasOwnProperty('CorporateStructureLink')) {
        obj['CorporateStructureLink'] = CorporateStructureLink.constructFromObject(data['CorporateStructureLink']);
      }
      if (data.hasOwnProperty('LastUpdate')) {
        obj['LastUpdate'] = ApiClient.convertToType(data['LastUpdate'], 'Date');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Array.<module:model/ForecastModelDataEntry>} Entries
   */
  exports.prototype['Entries'] = undefined;
  /**
   * @member {Integer} ModelID
   * @default 0
   */
  exports.prototype['ModelID'] = 0;
  /**
   * @member {Integer} FatherID
   */
  exports.prototype['FatherID'] = undefined;
  /**
   * @member {Integer} ChildrenTrackingLevelID
   */
  exports.prototype['ChildrenTrackingLevelID'] = undefined;
  /**
   * @member {module:model/CorporateStructureLink} CorporateStructureLink
   */
  exports.prototype['CorporateStructureLink'] = undefined;
  /**
   * @member {Date} LastUpdate
   */
  exports.prototype['LastUpdate'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


